module.exports = __webpack_public_path__ + "static/media/churchview_home.3f57506a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Media/churchview_home.jpg
// module id = 495
// module chunks = 0